import React from 'react';
import CopyClipboard from 'components/CopyClipboard';
import EmailIcon from 'svg/EmailIcon';
import TelephoneIcon from 'svg/TelephoneIcon';
import PhoneNumber from 'components/PhoneNumber';
import styles from './news.module.scss';

const Contact = ({ contactData }) => {
  if (!contactData || Object.keys(contactData).length === 0) return <></>;
  return (
    <div className={styles.contact}>
      <h2>Press Contact</h2>
      <p>{contactData?.name || ''}</p>
      <span>{contactData?.position || ''}</span>
      <div className={styles.link}>
        <div>
          <TelephoneIcon />
          <a href={`tel:${contactData?.telephone || ''}`}>
            <PhoneNumber number={contactData?.telephone || ''}></PhoneNumber>
          </a>
        </div>
        <div>
          <EmailIcon />
          <CopyClipboard id="email" text={contactData?.email || ''} />
        </div>
      </div>
    </div>
  );
};

export default Contact;
